// เติมโปรไฟล์เต็มให้ session ที่มาทาง SSO
//
// token จาก fragment มีแค่รหัสพนักงาน — ไม่มีชื่อไทย ตำแหน่ง แผนก หรือรูป
// เมนูโปรไฟล์จึงขึ้นเป็นตัวเลขรหัสอยู่พักหนึ่ง ที่นี่ยิง /wazzup/profile ครั้งเดียว
// แล้วรวมค่าเข้า session เดิม (token ไม่แตะ)
//
// ล้มเหลวไม่เป็นไร — ถือว่าไม่มีข้อมูลเสริม ไม่ใช่ session ตาย (ดู RELAY_PREFIXES)
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { authKeys, fetchMyProfile } from "../api/auth-api";
import { setSession } from "../lib/session";
import { sessionSet } from "./session-slice";

export function useSessionProfile(): void {
  const session = useAppSelector((s) => s.session.current);
  const dispatch = useAppDispatch();
  const token = session?.access_token ?? "";
  // ดึงเฉพาะ SSO และเฉพาะตอนที่ยังไม่เคยถาม — login ด้วยรหัสผ่านได้มาครบตอน login แล้ว
  const needed = !!token && session?.via === "sso" && !session?.profileFetched;

  const { data } = useQuery({
    queryKey: authKeys.profile(token),
    queryFn: () => fetchMyProfile(token),
    enabled: needed,
    retry: false,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (!data || !needed) return;
    const merged = {
      ...session!,
      empCode: data.empCode || session!.empCode,
      empThaiName: data.empThaiName || undefined,
      // ชื่อจาก claim เป็นรหัสตัวเลข ของจริงจาก IAM ดีกว่าเสมอถ้ามี
      empEngName: data.empEngName || session!.empEngName,
      nickName: data.nickName || session!.nickName,
      positionName: data.positionName || undefined,
      departmentName: data.departmentName || undefined,
      profileURL: data.profileURL || undefined,
      roles: data.userRole?.length ? data.userRole : session!.roles,
      profileFetched: true,
    };
    // เขียนลง storage ด้วย ไม่งั้น reload แล้วต้องดึงใหม่ทุกครั้ง
    setSession(merged);
    dispatch(sessionSet(merged));
  }, [data, needed, session, dispatch]);
}
